export default __webpack_public_path__ + "static/media/dob_select_icon.e22c8846.svg";